export const sortCountiesByStates = counties =>
  counties.reduce(
    (acc, countyOption) => {
      const { state } = countyOption;

      if (!acc[state]) {
        acc[state] = [];
      }

      const extendedCounty = {
        ...countyOption,
        key: `${countyOption.state}-${countyOption.value}`,
      };

      acc[state].push(extendedCounty);
      acc.ALL_COUNTIES.push(extendedCounty);

      return acc;
    },
    { ALL_COUNTIES: [] },
  );
